<template>
  <div v-if="index === step">
    <step-title :navItems="navItems" :index="index" :step="step" />

    <div class="container mt-3 pt-5 pb-5 bg-white">
      <div class="card text-center border-0">
        <div class="card-header border-0 bg-transparent">
          <slot name="header"></slot>
        </div>

        <div class="card-body bg-transparent" style="min-height: 45vh;">
          <slot name="body"></slot>
        </div>

        <div class="card-footer text-muted border-0 bg-transparent">
          <slot name="footer">
            <div class="row">
              <div class="col-1">
                <button class="btn btn-block" @click.stop.prevent="prev()">
                  <img src="~../../assets/image/icon/step_back.png" />
                </button>
              </div>

              <div class="col-4 offset-3">
                <button class="btn btn-success btn-block" @click.stop.prevent="next()">{{ step < navItems.length - 1 ? '下一步' : '完成' }}</button>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepTitle from './StepTitle'

export default {

  name: 'step',

  components: {
    StepTitle
  },

  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },

    index: {
      type: Number,
      required: true,
      default: 1
    },

    step: {
      type: Number,
      required: true,
      default: 1
    }
  },

  methods: {
    prev () {
      if (this.step > 1) {
        this.$emit('step', this.step - 1)
      } else {
        this.$emit('back')
      }
    },

    next () {
      if (this.step < this.navItems.length - 1) {
        this.$emit('step', this.step + 1)
      } else {
        this.$emit('finish')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// Step.vue?0c5cb3c0